import {
  get_currentSession2ignzypsmrqzv as get_currentSession,
  installLoggedOutErrors2aolzrsu041sp as installLoggedOutErrors,
  get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull,
} from './sdk/currentSession.mjs';
import {
  ID2ebczrc12h07k as ID,
  UserRole_Admin_getInstance1ewshxr51h257 as UserRole_Admin_getInstance,
  UserRole_Developer_getInstance37yg34uou1phs as UserRole_Developer_getInstance,
  UserRole_Root_getInstance2onjxwzt8221j as UserRole_Root_getInstance,
} from '../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/models.mjs';
import { installSmartHandlersfwcvh69h3js4 as installSmartHandlers } from '../../../../kiteui-library/com/lightningkite/kiteui/exceptions/handling.mjs';
import { installLsError111711da0k22u as installLsError } from '../../../../lightning-server-kiteui-client/com/lightningkite/kiteui/exceptions/LsErrorHandlers.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { reactiveSuspendingtu9o1tcdi36e as reactiveSuspending } from '../../../../reactive/com/lightningkite/reactive/context/ReactiveContextSuspending.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { checkAppVersion2crh954ac2m1p as checkAppVersion } from './views/checkAppVersion.mjs';
import { CoordinatorFrame1xeiax3dpykfa as CoordinatorFrame } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/CoordinatorFrame.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  set_pageNavigator2tlfgk6pqrj4q as set_pageNavigator,
  get_pageNavigatorp3to6r4j8ctv as get_pageNavigator,
} from '../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { bindToPlatform1wt9rhq76dpm9 as bindToPlatform } from '../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.js.mjs';
import {
  set_overlayFramep1ecbdlnexqw as set_overlayFrame,
  set_coordinatorFrame2x7bf8vqorao5 as set_coordinatorFrame,
} from '../../../../kiteui-library/com/lightningkite/kiteui/views/l2/appBase.mjs';
import {
  get_logoSquareqp8q36rlwdx7 as get_logoSquare,
  get_logoHorizontal20fghqlajlxu1 as get_logoHorizontal,
  get_logoSquareSimplified1ogjq1fkp7vtq as get_logoSquareSimplified,
  get_dashboard1ifq0xp2aghm5 as get_dashboard,
  get_familyGroupcn6iisky16qc as get_familyGroup,
  get_homeWork3roiugbpal7ja as get_homeWork,
  get_payments1u8br6msk8i66 as get_payments,
  get_circleFilled1igein81c6nk0 as get_circleFilled,
  get_arrowForward16hp7dhxwxirj as get_arrowForward,
} from './icons.mjs';
import { Companion_getInstance2u620q9r4ejbj as Companion_getInstance } from '../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  navSidebar3k1gob5isog5l as navSidebar,
  Link1sktol1xxfdlo as Link,
  Group2011jxjxf0ish as Group,
  Action27adr0bswxodr as Action,
  Custom2ic00hnkt7wt3 as Custom,
} from './forked-nav.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  requestNotificationPermissionsg3jo4mpz20gg as requestNotificationPermissions,
  notificationPermissions3o42d5ddpz7h as notificationPermissions,
  fcmSetup15yguhbnhle9q as fcmSetup,
} from './utils/fcmSetup.js.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import {
  get_stringsy7vodl9dj0ya as get_strings,
  get_entries3f2xe6etyinaj as get_entries,
} from './strings.mjs';
import {
  confirmDanger3l3hm6j4w4gpl as confirmDanger,
  text189ciz0cnr32o as text,
} from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KiteUiCoroutineScopeHelpers25rj47zs39igb as KiteUiCoroutineScopeHelpers } from '../../../../kiteui-library/com/lightningkite/kiteui/views/KiteUiCoroutineScopeHelpers.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_0 } from '../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
  listOf1jh22dvmctj1r as listOf,
  emptyList1g2z5xcrvp2zy as emptyList,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { HomePage3ptt6l367zajb as HomePage } from './views/HomeScreen.mjs';
import { FamiliesListPage2r5h75kkdixvz as FamiliesListPage } from './views/families/FamilyListPage.mjs';
import { ChildrenListPage2q8x8yakd8gse as ChildrenListPage } from './views/children/ChildrenListPage.mjs';
import { ChildPlacementsListPage3kc05o0qpi5ea as ChildPlacementsListPage } from './views/children/ChildPlacementsListPage.mjs';
import { FamilyApplicationsListPage36qv7eutg9abf as FamilyApplicationsListPage } from './views/applications/FamilyApplicationsListPage.mjs';
import { ProvidersListPage1qhw10fj2zdjm as ProvidersListPage } from './views/providers/ProvidersListPage.mjs';
import { LocationsListPage204x74tlyxper as LocationsListPage } from './views/locations/LocationsListPage.mjs';
import { AttendancePeriodsListPagekcmctzhabmp9 as AttendancePeriodsListPage } from './views/attendance/AttendancePeriodsListPage.mjs';
import { ProviderApplicationsListPagedp7b45wy4hgv as ProviderApplicationsListPage } from './views/applications/ProviderApplicationsListPage.mjs';
import { EmployersListPage35v89m7b6r55o as EmployersListPage } from './views/employers/EmployersListPage.mjs';
import { EmployerCostCalculatorPage3hdtsayh3aqer as EmployerCostCalculatorPage } from './views/employers/EmployerCostCalculatorPage.mjs';
import { GrantsListPageastthp822mlu as GrantsListPage } from './views/grants/GrantsListPage.mjs';
import { CloseOutPagesekceysksiq3 as CloseOutPage } from './views/closeout/CloseOutPage.mjs';
import { RemittancesListPage22q46xpibhdg4 as RemittancesListPage } from './views/remittances/RemittancesListPage.mjs';
import { BalanceSheetPage2218um6yj4e9j as BalanceSheetPage } from './views/reports/BalanceSheetPage.mjs';
import { DayTotalsPage3tkd9ei9dl3us as DayTotalsPage } from './views/reports/DayTotalsPage.mjs';
import { SingleDaysPage2w42wjhncrkcq as SingleDaysPage } from './views/reports/SingleDaysPage.mjs';
import { PlacementTotalsPage1pmi1f9h9gb4a as PlacementTotalsPage } from './views/reports/PlacementTotalsPage.mjs';
import { SurveyListPage1qf6jxjitzrxe as SurveyListPage } from './views/surveys/SurveyListPage.mjs';
import { UserListPagefht460rwsun7 as UserListPage } from './views/users/UserListPage.mjs';
import { CareProgramTemplatesListPage3j0tqz0uh3p6c as CareProgramTemplatesListPage } from './views/rates/CareRateTemplatesListPage.mjs';
import { ProfilePagezfg19fjwgylu as ProfilePage } from './views/users/ProfilePage.mjs';
import {
  listOfvhqybd2zx248 as listOf_0,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  get_unpadded1ygmnwh0rw79t as get_unpadded,
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
} from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { MenuButton27en4jjgdkozz as MenuButton } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/MenuButton.commonHtml.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
  ListSemantic_getInstance2e62q1se6gw64 as ListSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  plus354lvypr4cqa1 as plus,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
} from '../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
} from '../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  shownWhen3t7othivfr11 as shownWhen,
  weight31wqab1913ly4 as weight,
} from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  NumberBadgeSemantic_getInstance2wez41hmadmon as NumberBadgeSemantic_getInstance,
  styledHeaderwng1nfqibdig as styledHeader,
  TextOnlyButtonSemantic_getInstance26zmm1m4hs065 as TextOnlyButtonSemantic_getInstance,
  SmallTextSemantic_getInstance3ht14r7yzc9rl as SmallTextSemantic_getInstance,
  UnreadNotificationSemantic_getInstance2xhggpn2jfpdt as UnreadNotificationSemantic_getInstance,
} from './theme/semantics.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_dp28ag147e4p5cz as get_dp,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { Recycler21f097l2zl8cft as Recycler2 } from '../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.mjs';
import { RecyclerViewPlacerVerticalGrid1jojlivaz3vdj as RecyclerViewPlacerVerticalGrid } from '../../../../kiteui-library/com/lightningkite/kiteui/views/l2/RecyclerViewPlacerVerticalGrid.mjs';
import { Action2nhdpxpznfsbd as Action_0 } from '../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { Link2eefk0yp041c4 as Link_0 } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { onNavigate2wu3qzsseblgb as onNavigate } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance,
  renderToStringprxvmjepz2st as renderToString,
} from '../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import {
  substringAfter35b3qhto7hchb as substringAfter,
  substringAfter1hku067gwr5ve as substringAfter_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Companion_getInstance1h51zwdsitw8c as Companion_getInstance_1 } from '../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { get_AutoRoutes2trt04tweryz2 as get_AutoRoutes } from './views/autoroutes.mjs';
import { Empty_instancerdfpp8xjdvlo as Empty_instance } from '../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { children3c86uuk2wm9cf as children } from '../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.ext.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Notification1y91jemwm75tr as Notification } from '../../../../lightning-server-notifications-shared/com/lightningkite/lightningserver/notifications/notificationModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TCGNotification15rsix3sbs9g0 as TCGNotification } from '../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/notifications.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_usersuhqswqrijs4 as get_user,
  get_read2fqnxj4c930ns as get_read,
} from '../../../../lightning-server-notifications-shared/com/lightningkite/lightningserver/notifications/ModelFields-2090458501.mjs';
import { eq353yrgcpovoi1 as eq } from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { and3dbt2f202um49 as and } from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { ModificationBuilder10ot0rvxki4iq as ModificationBuilder } from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/ModificationBuilder.mjs';
import { now2qufyxzn5e863 as now } from '../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { MassModification2547e91qtpdf9 as MassModification } from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/MassModification.mjs';
import { closePopoversckn4u815mr3s as closePopovers } from '../../../../kiteui-library/com/lightningkite/kiteui/views/ViewContextExtensions.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { NotificationListPagec9eun7x3iu4r as NotificationListPage } from './views/NotificationListPage.mjs';
import { get_tcgTheme1nse0bsqncjv0 as get_tcgTheme } from './theme/theme.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_defaultTheme() {
  _init_properties_App_kt__fk8usv();
  return defaultTheme;
}
var defaultTheme;
function get_appTheme() {
  _init_properties_App_kt__fk8usv();
  return appTheme;
}
var appTheme;
function get_fcmToken() {
  _init_properties_App_kt__fk8usv();
  return fcmToken;
}
var fcmToken;
var setFcmToken;
function get_backOfficeRoles() {
  _init_properties_App_kt__fk8usv();
  return backOfficeRoles;
}
var backOfficeRoles;
function isBackOfficeUser(_this__u8e3s4) {
  _init_properties_App_kt__fk8usv();
  var tmp0_elvis_lhs = _this__u8e3s4.invoke_r7m7el_k$(get_currentSession());
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var session = tmp;
  var tmp1_safe_receiver = _this__u8e3s4.invoke_r7m7el_k$(session.get_users_izsycf_k$().get_6ueaa7_k$(new (ID())(session.userId_1)));
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.role_1;
  var tmp_0;
  if (tmp2_elvis_lhs == null) {
    return false;
  } else {
    tmp_0 = tmp2_elvis_lhs;
  }
  var role = tmp_0;
  return get_backOfficeRoles().contains_aljjnj_k$(role);
}
function managesFamilies(_this__u8e3s4) {
  _init_properties_App_kt__fk8usv();
  var tmp0_elvis_lhs = _this__u8e3s4.invoke_r7m7el_k$(get_currentSession());
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var session = tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  return !_this__u8e3s4.invoke_r7m7el_k$(session.self_1).managesFamilies_1.isEmpty_y1axqb_k$();
}
function managesProviders(_this__u8e3s4) {
  _init_properties_App_kt__fk8usv();
  var tmp0_elvis_lhs = _this__u8e3s4.invoke_r7m7el_k$(get_currentSession());
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var session = tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  return !_this__u8e3s4.invoke_r7m7el_k$(session.self_1).managesProviders_1.isEmpty_y1axqb_k$();
}
function managesLocations(_this__u8e3s4) {
  _init_properties_App_kt__fk8usv();
  var tmp0_elvis_lhs = _this__u8e3s4.invoke_r7m7el_k$(get_currentSession());
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var session = tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  return !_this__u8e3s4.invoke_r7m7el_k$(session.self_1).managesLocations_1.isEmpty_y1axqb_k$();
}
function managesEmployers(_this__u8e3s4) {
  _init_properties_App_kt__fk8usv();
  var tmp0_elvis_lhs = _this__u8e3s4.invoke_r7m7el_k$(get_currentSession());
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var session = tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  return !_this__u8e3s4.invoke_r7m7el_k$(session.self_1).managesEmployers_1.isEmpty_y1axqb_k$();
}
function seesCareDetail(_this__u8e3s4) {
  _init_properties_App_kt__fk8usv();
  return isBackOfficeUser(_this__u8e3s4) || managesFamilies(_this__u8e3s4) || managesProviders(_this__u8e3s4) || managesLocations(_this__u8e3s4);
}
function managesSomething(_this__u8e3s4) {
  _init_properties_App_kt__fk8usv();
  return isBackOfficeUser(_this__u8e3s4) || managesFamilies(_this__u8e3s4) || managesProviders(_this__u8e3s4) || managesLocations(_this__u8e3s4) || managesEmployers(_this__u8e3s4);
}
function app(_this__u8e3s4, navigator) {
  _init_properties_App_kt__fk8usv();
  installSmartHandlers(_this__u8e3s4.get_context_h02k06_k$().exceptionHandlers_1);
  installLsError(_this__u8e3s4.get_context_h02k06_k$().exceptionHandlers_1);
  installLoggedOutErrors(_this__u8e3s4.get_context_h02k06_k$().exceptionHandlers_1);
  var tmp = get_AppScope();
  reactiveSuspending(tmp, app$slambda(_this__u8e3s4));
  checkAppVersion(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.produceExactlyOneElement' call
  // Inline function 'com.lightningkite.kiteui.views.produceAtMostOneElement' call
  // Inline function 'com.lightningkite.kiteui.views.produceAtMostOneUnsafe' call
  var output = {_v: null};
  var writer = new (app$$inlined$produceExactlyOneElement$1())(_this__u8e3s4, output);
  // Inline function 'com.lightningkite.kiteui.views.l2.appBase' call
  // Inline function 'com.lightningkite.kiteui.views.direct.coordinatorFrame' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (CoordinatorFrame())(writer.get_context_h02k06_k$());
  ensureOutermostElement(element);
  writer.willAddChild_hz2iwc_k$(element);
  element.set_debugName_wihv62_k$('appBase');
  set_pageNavigator(element.get_context_h02k06_k$(), navigator);
  bindToPlatform(navigator, element.get_context_h02k06_k$());
  set_overlayFrame(element.get_context_h02k06_k$(), element);
  set_coordinatorFrame(element.get_context_h02k06_k$(), element);
  var tmp0_appLogoCompact = get_logoSquare().toImageSource_vhg6iu_k$(Companion_getInstance().white_1);
  var tmp1_appLogoExpanded = get_logoHorizontal().toImageSource_vhg6iu_k$(Companion_getInstance().white_1);
  var tmp2_appLogoIcon = get_logoSquareSimplified().toImageSource_vhg6iu_k$(Companion_getInstance().fromHexString_vb3go_k$('#0b56a4'));
  var tmp_0 = ($this$navSidebar) => {
    var tmp = $this$navSidebar.invoke_r7m7el_k$(navigator.currentPage_1);
    return !(!(tmp == null) ? isInterface(tmp, FullscreenPage()) : false);
  };
  var tmp_1 = app$lambda;
  var tmp_2 = app$lambda_0;
  navSidebar(element, tmp0_appLogoCompact, tmp1_appLogoExpanded, tmp2_appLogoIcon, 'TCG CARES', VOID, VOID, tmp_0, tmp_1, tmp_2, app$lambda_1);
  element.onStartup_vrxh3i_k$();
  writer.addChild_2qpft2_k$(element);
  var tmp0_elvis_lhs = output._v;
  var tmp_3;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Produced no elements at this layer, but expected one.');
  } else {
    tmp_3 = tmp0_elvis_lhs;
  }
  var rootView = tmp_3;
}
var FullscreenPageClass;
function FullscreenPage() {
  if (FullscreenPageClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'FullscreenPage');
    FullscreenPageClass = $;
  }
  return FullscreenPageClass;
}
function setFcmToken$lambda(token) {
  _init_properties_App_kt__fk8usv();
  get_fcmToken().set_value_v1vabv_k$(token);
  return Unit_instance;
}
function app$slambda$slambda() {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* requestNotificationPermissions($completion);
    return Unit_instance;
  }), 0);
}
function app$slambda($this_app) {
  return constructCallableReference(($this$reactiveSuspending, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSession();
    if ((yield* await_0(this_0, $completion)) == null) {
      return Unit_instance;
    }
    var permission = yield* notificationPermissions($completion);
    var tmp_0;
    switch (permission) {
      case false:
        tmp_0 = Unit_instance;
        break;
      case true:
        fcmSetup();
        tmp_0 = Unit_instance;
        break;
      case null:
        var tmp_1 = $this_app.get_context_h02k06_k$();
        // Inline function 'com.lightningkite.reactive.context.invoke' call

        var this_1 = get_strings(AppState_getInstance());
        var tmp_2 = (yield* await_1(this_1, $completion)).get_notificationsPromptTitle_6gox63_k$();
        // Inline function 'com.lightningkite.reactive.context.invoke' call

        var this_2 = get_strings(AppState_getInstance());
        var tmp_3 = (yield* await_1(this_2, $completion)).get_notificationsPromptBody_22ny2t_k$();
        // Inline function 'com.lightningkite.reactive.context.invoke' call

        var this_3 = get_strings(AppState_getInstance());
        var tmp_4 = (yield* await_1(this_3, $completion)).get_notificationsPromptAllow_6r39bu_k$();
        confirmDanger(tmp_1, tmp_2, tmp_3, tmp_4, VOID, app$slambda$slambda());
        tmp_0 = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return Unit_instance;
  }), 1);
}
var app$$inlined$produceExactlyOneElement$1Class;
function app$$inlined$produceExactlyOneElement$1() {
  if (app$$inlined$produceExactlyOneElement$1Class === VOID) {
    class $ {
      constructor($this, $output) {
        this.$this_1 = $this;
        this.$output_1 = $output;
        this.$$delegate_0__1 = $this;
      }
      addChild_2qpft2_k$(element) {
        if (!(this.$output_1._v == null))
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Produced more than one element at this layer, but only one was expected.');
        this.$this_1.addChild_2qpft2_k$(element);
        this.$output_1._v = element;
      }
      get_context_h02k06_k$() {
        return this.$$delegate_0__1.get_context_h02k06_k$();
      }
      willAddChild_hz2iwc_k$(element) {
        this.$$delegate_0__1.willAddChild_hz2iwc_k$(element);
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.$$delegate_0__1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [KiteUiCoroutineScopeHelpers()]);
    app$$inlined$produceExactlyOneElement$1Class = $;
  }
  return app$$inlined$produceExactlyOneElement$1Class;
}
function app$lambda($this$navSidebar) {
  _init_properties_App_kt__fk8usv();
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var tmp = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_navDashboardTitle_9up0g2_k$();
  var tmp_0 = get_dashboard(Companion_getInstance_0());
  this_0.add_utx5q5_k$(new (Link())(tmp, VOID, tmp_0, VOID, app$lambda$lambda));
  if (managesSomething($this$navSidebar)) {
    if (isBackOfficeUser($this$navSidebar) || managesFamilies($this$navSidebar)) {
      var tmp_1 = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudGroupProgramTitle_ph6e0k_k$();
      var tmp_2 = get_familyGroup(Companion_getInstance_0());
      var tmp_3 = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyListTitle_7vfhpp_k$();
      // Inline function 'kotlin.takeIf' call
      var this_1 = new (Link())(tmp_3, VOID, VOID, VOID, app$lambda$lambda_0);
      var tmp_4;
      if (isBackOfficeUser($this$navSidebar) || managesFamilies($this$navSidebar)) {
        tmp_4 = this_1;
      } else {
        tmp_4 = null;
      }
      var tmp_5 = tmp_4;
      var tmp_6 = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childrenListTitle_3nn3hu_k$();
      // Inline function 'kotlin.takeIf' call
      var this_2 = new (Link())(tmp_6, VOID, VOID, VOID, app$lambda$lambda_1);
      var tmp_7;
      if (isBackOfficeUser($this$navSidebar) || managesFamilies($this$navSidebar)) {
        tmp_7 = this_2;
      } else {
        tmp_7 = null;
      }
      var tmp_8 = tmp_7;
      // Inline function 'kotlin.takeIf' call
      var this_3 = new (Link())('Child Placements', VOID, VOID, VOID, app$lambda$lambda_2);
      var tmp_9;
      if (isBackOfficeUser($this$navSidebar)) {
        tmp_9 = this_3;
      } else {
        tmp_9 = null;
      }
      var tmp_10 = tmp_9;
      // Inline function 'kotlin.let' call
      var it = $this$navSidebar.invoke_r7m7el_k$($this$navSidebar.invoke_r7m7el_k$(get_currentSessionNotNull()).pendingFamilyInvites_1);
      var tmp_11 = it > 0 ? it : null;
      // Inline function 'kotlin.takeIf' call
      var this_4 = new (Link())('Pending Family Invites', VOID, VOID, tmp_11, app$lambda$lambda_3);
      var tmp_12;
      if (isBackOfficeUser($this$navSidebar)) {
        tmp_12 = this_4;
      } else {
        tmp_12 = null;
      }
      var tmp$ret$12 = tmp_12;
      this_0.add_utx5q5_k$(new (Group())(tmp_1, tmp_2, listOfNotNull([tmp_5, tmp_8, tmp_10, tmp$ret$12])));
    }
    var tmp_13 = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudGroupNetworkTitle_o69yjm_k$();
    var tmp_14 = get_homeWork(Companion_getInstance_0());
    var tmp_15 = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_navProvidersTitle_oa0ysw_k$();
    var tmp_16 = new (Link())(tmp_15, VOID, VOID, VOID, app$lambda$lambda_4);
    var tmp_17 = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_navCareLocationsTitle_2k6n4r_k$();
    var tmp_18 = new (Link())(tmp_17, VOID, VOID, VOID, app$lambda$lambda_5);
    var tmp_19 = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendancePeriodsPageTitle_1e29ef_k$();
    // Inline function 'kotlin.takeIf' call
    var this_5 = new (Link())(tmp_19, VOID, VOID, VOID, app$lambda$lambda_6);
    var tmp_20;
    if (isBackOfficeUser($this$navSidebar) || managesLocations($this$navSidebar) || managesProviders($this$navSidebar)) {
      tmp_20 = this_5;
    } else {
      tmp_20 = null;
    }
    var tmp_21 = tmp_20;
    // Inline function 'kotlin.let' call
    var it_0 = $this$navSidebar.invoke_r7m7el_k$($this$navSidebar.invoke_r7m7el_k$(get_currentSessionNotNull()).pendingProviderInvites_1);
    var tmp_22 = it_0 > 0 ? it_0 : null;
    // Inline function 'kotlin.takeIf' call
    var this_6 = new (Link())('Pending Provider Invites', VOID, VOID, tmp_22, app$lambda$lambda_7);
    var tmp_23;
    if (isBackOfficeUser($this$navSidebar)) {
      tmp_23 = this_6;
    } else {
      tmp_23 = null;
    }
    var tmp$ret$18 = tmp_23;
    this_0.add_utx5q5_k$(new (Group())(tmp_13, tmp_14, listOfNotNull([tmp_16, tmp_18, tmp_21, tmp$ret$18])));
    var tmp_24 = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudGroupFundingTitle_rkjttf_k$();
    var tmp_25 = get_payments(Companion_getInstance_0());
    var tmp_26 = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_navEmployersTitle_5ougl6_k$();
    // Inline function 'kotlin.takeIf' call
    var this_7 = new (Link())(tmp_26, VOID, VOID, VOID, app$lambda$lambda_8);
    var tmp_27;
    if (isBackOfficeUser($this$navSidebar) || managesEmployers($this$navSidebar) || managesFamilies($this$navSidebar)) {
      tmp_27 = this_7;
    } else {
      tmp_27 = null;
    }
    var tmp_28 = tmp_27;
    // Inline function 'kotlin.takeIf' call
    var this_8 = new (Link())('Employer Cost Calculator', VOID, VOID, VOID, app$lambda$lambda_9);
    var tmp_29;
    if (isBackOfficeUser($this$navSidebar) || managesEmployers($this$navSidebar) || managesFamilies($this$navSidebar)) {
      tmp_29 = this_8;
    } else {
      tmp_29 = null;
    }
    var tmp_30 = tmp_29;
    var tmp_31 = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_navGrantsTitle_6gc2p3_k$();
    var tmp_32 = new (Link())(tmp_31, VOID, VOID, VOID, app$lambda$lambda_10);
    var tmp_33 = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_navCloseOutTitle_69wx5k_k$();
    // Inline function 'kotlin.takeIf' call
    var this_9 = new (Link())(tmp_33, VOID, VOID, VOID, app$lambda$lambda_11);
    var tmp_34;
    if (isBackOfficeUser($this$navSidebar)) {
      tmp_34 = this_9;
    } else {
      tmp_34 = null;
    }
    var tmp_35 = tmp_34;
    var tmp_36 = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_navRemittancesTitle_qthgnx_k$();
    // Inline function 'kotlin.takeIf' call
    var this_10 = new (Link())(tmp_36, VOID, VOID, VOID, app$lambda$lambda_12);
    var tmp_37;
    if (isBackOfficeUser($this$navSidebar) || managesProviders($this$navSidebar)) {
      tmp_37 = this_10;
    } else {
      tmp_37 = null;
    }
    var tmp$ret$26 = tmp_37;
    this_0.add_utx5q5_k$(new (Group())(tmp_24, tmp_25, listOfNotNull([tmp_28, tmp_30, tmp_32, tmp_35, tmp$ret$26])));
    if (seesCareDetail($this$navSidebar)) {
      var tmp_38 = Companion_getInstance_0().list_1;
      // Inline function 'kotlin.takeIf' call
      var this_11 = new (Link())('Balance Sheet', VOID, VOID, VOID, app$lambda$lambda_13);
      var tmp_39;
      if (isBackOfficeUser($this$navSidebar)) {
        tmp_39 = this_11;
      } else {
        tmp_39 = null;
      }
      var tmp_40 = tmp_39;
      var tmp_41 = new (Link())('Billed Day Totals', VOID, VOID, VOID, app$lambda$lambda_14);
      var tmp_42 = new (Link())('Billed Days', VOID, VOID, VOID, app$lambda$lambda_15);
      // Inline function 'kotlin.takeIf' call
      var this_12 = new (Link())('Placement Totals', VOID, VOID, VOID, app$lambda$lambda_16);
      var tmp_43;
      if (managesProviders($this$navSidebar) || managesLocations($this$navSidebar)) {
        tmp_43 = this_12;
      } else {
        tmp_43 = null;
      }
      var tmp$ret$30 = tmp_43;
      this_0.add_utx5q5_k$(new (Group())('Reports', tmp_38, listOfNotNull([tmp_40, tmp_41, tmp_42, tmp$ret$30])));
    }
    if (isBackOfficeUser($this$navSidebar)) {
      var tmp_44 = Companion_getInstance_0().list_1;
      this_0.add_utx5q5_k$(new (Link())('Surveys', VOID, tmp_44, VOID, app$lambda$lambda_17));
      var tmp_45 = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudGroupAdminTitle_bj6jxb_k$();
      var tmp_46 = Companion_getInstance_0().settings_1;
      var tmp_47 = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_navUsersTitle_3xs496_k$();
      var tmp_48 = new (Link())(tmp_47, VOID, VOID, VOID, app$lambda$lambda_18);
      var tmp_49 = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateTemplatesPageTitle_qntbdl_k$();
      this_0.add_utx5q5_k$(new (Group())(tmp_45, tmp_46, listOf([tmp_48, new (Link())(tmp_49, VOID, VOID, VOID, app$lambda$lambda_19)])));
    }
  }
  var tmp_50 = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_navProfileTitle_ud0y1_k$();
  var tmp_51 = Companion_getInstance_0().person_1;
  this_0.add_utx5q5_k$(new (Link())(tmp_50, VOID, tmp_51, VOID, app$lambda$lambda_20));
  return this_0.build_nmwvly_k$();
}
function app$lambda$lambda() {
  _init_properties_App_kt__fk8usv();
  return new (HomePage())();
}
function app$lambda$lambda_0() {
  _init_properties_App_kt__fk8usv();
  return new (FamiliesListPage())();
}
function app$lambda$lambda_1() {
  _init_properties_App_kt__fk8usv();
  return new (ChildrenListPage())();
}
function app$lambda$lambda_2() {
  _init_properties_App_kt__fk8usv();
  return new (ChildPlacementsListPage())();
}
function app$lambda$lambda_3() {
  _init_properties_App_kt__fk8usv();
  return new (FamilyApplicationsListPage())();
}
function app$lambda$lambda_4() {
  _init_properties_App_kt__fk8usv();
  return new (ProvidersListPage())();
}
function app$lambda$lambda_5() {
  _init_properties_App_kt__fk8usv();
  return new (LocationsListPage())();
}
function app$lambda$lambda_6() {
  _init_properties_App_kt__fk8usv();
  return new (AttendancePeriodsListPage())();
}
function app$lambda$lambda_7() {
  _init_properties_App_kt__fk8usv();
  return new (ProviderApplicationsListPage())();
}
function app$lambda$lambda_8() {
  _init_properties_App_kt__fk8usv();
  return new (EmployersListPage())();
}
function app$lambda$lambda_9() {
  _init_properties_App_kt__fk8usv();
  return new (EmployerCostCalculatorPage())();
}
function app$lambda$lambda_10() {
  _init_properties_App_kt__fk8usv();
  return new (GrantsListPage())();
}
function app$lambda$lambda_11() {
  _init_properties_App_kt__fk8usv();
  return new (CloseOutPage())();
}
function app$lambda$lambda_12() {
  _init_properties_App_kt__fk8usv();
  return new (RemittancesListPage())();
}
function app$lambda$lambda_13() {
  _init_properties_App_kt__fk8usv();
  return new (BalanceSheetPage())();
}
function app$lambda$lambda_14() {
  _init_properties_App_kt__fk8usv();
  return new (DayTotalsPage())();
}
function app$lambda$lambda_15() {
  _init_properties_App_kt__fk8usv();
  return new (SingleDaysPage())();
}
function app$lambda$lambda_16() {
  _init_properties_App_kt__fk8usv();
  return new (PlacementTotalsPage())();
}
function app$lambda$lambda_17() {
  _init_properties_App_kt__fk8usv();
  return new (SurveyListPage())();
}
function app$lambda$lambda_18() {
  _init_properties_App_kt__fk8usv();
  return new (UserListPage())();
}
function app$lambda$lambda_19() {
  _init_properties_App_kt__fk8usv();
  return new (CareProgramTemplatesListPage())();
}
function app$lambda$lambda_20() {
  _init_properties_App_kt__fk8usv();
  return new (ProfilePage())();
}
function app$lambda_0($this$navSidebar) {
  _init_properties_App_kt__fk8usv();
  var tmp = $this$navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_navSwitchLanguageTitle_6fj9xq_k$();
  var tmp_0 = Companion_getInstance_0().sync_1;
  return listOf_0(new (Action())(tmp, tmp_0, VOID, app$lambda$slambda($this$navSidebar)));
}
function app$lambda$slambda($this_navSidebar) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var entries = get_entries();
    yield* get_strings(AppState_getInstance()).set_revjhg_k$(entries.get_c1px32_k$(($this_navSidebar.invoke_r7m7el_k$(get_strings(AppState_getInstance())).ordinal_1 + 1 | 0) % entries.get_size_woubt6_k$() | 0), $completion);
    return Unit_instance;
  }), 0);
}
function app$lambda_1($this$navSidebar) {
  _init_properties_App_kt__fk8usv();
  var tmp = Companion_getInstance_0().notification_1;
  return listOf_0(new (Custom())('Notifications', tmp, ($this$Custom) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
    var this_0 = get_unpadded($this$Custom);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (MenuButton())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    var notifications = remember(VOID, VOID, VOID, VOID, app$lambda$lambda$lambda);
    var unreadNotifications = remember(VOID, VOID, VOID, VOID, app$lambda$lambda$lambda_0);
    element.requireClick_1 = true;
    // Inline function 'com.lightningkite.kiteui.views.compact' call
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_1 = themed(element, CompactSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    this_1.willAddChild_hz2iwc_k$(element_0);
    element_0.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (IconView())(element_0.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    element_0.willAddChild_hz2iwc_k$(element_1);
    element_1.set_source_3o5lkf_k$(Companion_getInstance_0().notification_1);
    var tmp = KMutableProperty0();
    var tmp_0 = IconView$_get_description_$ref_x7iif6(element_1);
    var tmp_1 = getPropertyCallableRef('description', 0, tmp, tmp_0, IconView$_set_description_$ref_rpvc1e(element_1));
    element_1.invoke_bnq13k_k$(tmp_1, app$lambda$lambda$lambda_1);
    element_1.onStartup_vrxh3i_k$();
    element_0.addChild_2qpft2_k$(element_1);
    var tmp_2 = get_centered(element_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    var this_2 = themed(shownWhen(tmp_2, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(unreadNotifications) > 0), NumberBadgeSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (TextView())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    this_2.willAddChild_hz2iwc_k$(element_2);
    var tmp_3 = KMutableProperty0();
    var tmp_4 = TextView$_get_content_$ref_4pzcwl(element_2);
    var tmp_5 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(element_2));
    element_2.invoke_bnq13k_k$(tmp_5, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(unreadNotifications).toString());
    element_2.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_2);
    element_0.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_0);
    element.opensMenu_gggyad_k$(($this$opensMenu) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_0 = sizeConstraints($this$opensMenu, VOID, VOID, VOID, VOID, VOID, get_rem(30), get_rem(30));
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_0.willAddChild_hz2iwc_k$(element);
      element.set_vertical_nuap32_k$(true);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_1 = weight(element, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      this_1.willAddChild_hz2iwc_k$(element_0);
      element_0.set_vertical_nuap32_k$(true);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = new (RowOrCol())(element_0.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      element_0.willAddChild_hz2iwc_k$(element_1);
      element_1.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      var this_2 = get_centered(element_1);
      var tmp = weight(this_2, 1.0);
      styledHeader(tmp, app$lambda$lambda$lambda$lambda);
      var tmp_0 = get_centered(element_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_3 = themed(shownWhen(tmp_0, VOID, VOID, app$lambda$lambda$lambda$lambda_0), TextOnlyButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (Button())(this_3.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      this_3.willAddChild_hz2iwc_k$(element_2);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_3 = new (RowOrCol())(element_2.get_context_h02k06_k$());
      ensureOutermostElement(element_3);
      element_2.willAddChild_hz2iwc_k$(element_3);
      element_3.set_vertical_nuap32_k$(false);
      element_3.set_gap_jwjroq_k$(get_dp(2));
      // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
      var this_4 = get_centered(element_3);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_4 = new (IconView())(this_4.get_context_h02k06_k$());
      ensureOutermostElement(element_4);
      this_4.willAddChild_hz2iwc_k$(element_4);
      element_4.set_source_3o5lkf_k$(Companion_getInstance_0().done_1.resize_q1xpz0_k$(get_rem(1)));
      var tmp_1 = KMutableProperty0();
      var tmp_2 = IconView$_get_description_$ref_x7iif6(element_4);
      var tmp_3 = getPropertyCallableRef('description', 0, tmp_1, tmp_2, IconView$_set_description_$ref_rpvc1e(element_4));
      element_4.invoke_bnq13k_k$(tmp_3, app$lambda$lambda$lambda$lambda_1);
      element_4.onStartup_vrxh3i_k$();
      this_4.addChild_2qpft2_k$(element_4);
      text(themed(get_bold(get_centered(element_3)), SmallTextSemantic_getInstance()), 'Mark all as read');
      element_3.onStartup_vrxh3i_k$();
      element_2.addChild_2qpft2_k$(element_3);
      onClick(element_2, VOID, VOID, VOID, app$lambda$lambda$lambda$slambda($this$navSidebar));
      element_2.onStartup_vrxh3i_k$();
      this_3.addChild_2qpft2_k$(element_2);
      element_1.onStartup_vrxh3i_k$();
      element_0.addChild_2qpft2_k$(element_1);
      var tmp_4 = get_centered(element_0);
      text(shownWhen(tmp_4, VOID, VOID, app$lambda$lambda$lambda$lambda_2), 'No notifications yet.');
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      var tmp$ret$38 = weight(element_0, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.direct.recyclerView' call
      var this_5 = themed(tmp$ret$38, ListSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_5 = Recycler2().new_com_lightningkite_kiteui_views_l2_Recycler2_cdij9p_k$(this_5.get_context_h02k06_k$(), true, null);
      ensureOutermostElement(element_5);
      this_5.willAddChild_hz2iwc_k$(element_5);
      element_5.set_placer_s41hzn_k$(new (RecyclerViewPlacerVerticalGrid())(1, VOID, true));
      var tmp_5 = app$lambda$lambda$lambda$lambda_3;
      children(element_5, notifications, tmp_5, ($this$children, notification) => {
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())($this$children.get_context_h02k06_k$());
        ensureOutermostElement(element);
        $this$children.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(false);
        var markRead = Action_0('Mark Read', VOID, VOID, VOID, VOID, VOID, app$lambda$lambda$lambda$lambda$slambda($this$navSidebar, notification));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp = weight(element, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_0 = dynamicThemed(tmp, ($this$dynamicThemed) => $this$dynamicThemed.invoke_r7m7el_k$(notification).read_1 == null ? UnreadNotificationSemantic_getInstance() : null);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (Link_0())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_0.willAddChild_hz2iwc_k$(element_0);
        onNavigate(element_0, VOID, VOID, VOID, app$lambda$lambda$lambda$lambda$slambda_0(element_0, markRead));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (RowOrCol())(element_0.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        element_0.willAddChild_hz2iwc_k$(element_1);
        element_1.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (IconView())(element_1.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        element_1.willAddChild_hz2iwc_k$(element_2);
        element_2.set_source_3o5lkf_k$(get_circleFilled(Companion_getInstance_0()).resize_q1xpz0_k$(get_rem_0(1.25)));
        var tmp_0 = KMutableProperty0();
        var tmp_1 = IconView$_get_description_$ref_x7iif6(element_2);
        var tmp_2 = getPropertyCallableRef('description', 0, tmp_0, tmp_1, IconView$_set_description_$ref_rpvc1e(element_2));
        element_2.invoke_bnq13k_k$(tmp_2, app$lambda$lambda$lambda$lambda$lambda);
        var tmp_3 = KMutableProperty0();
        var tmp_4 = IconView$_get_shown_$ref_js8irt(element_2);
        var tmp_5 = getPropertyCallableRef('shown', 0, tmp_3, tmp_4, IconView$_set_shown_$ref_9ilxmr(element_2));
        element_2.invoke_bnq13k_k$(tmp_5, ($this$invoke) => {
          var tmp0 = $this$invoke.invoke_r7m7el_k$(notifications);
          var tmp$ret$57;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.isEmpty_y1axqb_k$();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$57 = false;
              break $l$block_0;
            }
            var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              if (element.read_1 == null) {
                tmp$ret$57 = true;
                break $l$block_0;
              }
            }
            tmp$ret$57 = false;
          }
          return tmp$ret$57;
        });
        var tmp_6 = KMutableProperty0();
        var tmp_7 = IconView$_get_visible_$ref_7ldslk(element_2);
        var tmp_8 = getPropertyCallableRef('visible', 0, tmp_6, tmp_7, IconView$_set_visible_$ref_mp0dqc(element_2));
        element_2.invoke_bnq13k_k$(tmp_8, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(notification).read_1 == null);
        element_2.onStartup_vrxh3i_k$();
        element_1.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = weight(element_1, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_1.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(true);
        element_3.set_gap_jwjroq_k$(get_dp(0));
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_2 = dynamicThemed(element_3, ($this$dynamicThemed) => {
          var tmp;
          if ($this$dynamicThemed.invoke_r7m7el_k$(notification).read_1 == null) {
            // Inline function 'com.lightningkite.kiteui.models.ThemeDerivation' call
            tmp = new (app$$inlined$produceExactlyOneElement$5$1$8$8$10$1())();
          } else {
            tmp = null;
          }
          return tmp;
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (TextView())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_2.willAddChild_hz2iwc_k$(element_4);
        var tmp_9 = KMutableProperty0();
        var tmp_10 = TextView$_get_content_$ref_4pzcwl(element_4);
        var tmp_11 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb(element_4));
        element_4.invoke_bnq13k_k$(tmp_11, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(notification).content_1.subject_1);
        element_4.set_wraps_9wisy1_k$(false);
        element_4.set_ellipsis_rhzl3b_k$(true);
        element_4.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = themed(element_3, SmallTextSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_3.willAddChild_hz2iwc_k$(element_5);
        var tmp_12 = KMutableProperty0();
        var tmp_13 = TextView$_get_content_$ref_4pzcwl(element_5);
        var tmp_14 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, TextView$_set_content_$ref_pketfb(element_5));
        element_5.invoke_bnq13k_k$(tmp_14, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(notification).content_1.body_1);
        element_5.set_wraps_9wisy1_k$(false);
        element_5.set_ellipsis_rhzl3b_k$(true);
        element_5.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (TextView())(element_3.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        element_3.willAddChild_hz2iwc_k$(element_6);
        element_6.set_themeChoice_py59um_k$(element_6.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_15 = KMutableProperty0();
        var tmp_16 = TextView$_get_content_$ref_4pzcwl(element_6);
        var tmp_17 = getPropertyCallableRef('content', 0, tmp_15, tmp_16, TextView$_set_content_$ref_pketfb(element_6));
        element_6.invoke_bnq13k_k$(tmp_17, ($this$invoke) => renderToString($this$invoke.invoke_r7m7el_k$(notification).createdAt_1, RenderSize_Abbreviation_getInstance()));
        element_6.onStartup_vrxh3i_k$();
        element_3.addChild_2qpft2_k$(element_6);
        element_3.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_3);
        element_1.onStartup_vrxh3i_k$();
        element_0.addChild_2qpft2_k$(element_1);
        var tmp_18 = KMutableProperty0();
        var tmp_19 = Link$_get_to_$ref_jq7esp(element_0);
        var tmp_20 = getPropertyCallableRef('to', 0, tmp_18, tmp_19, Link$_set_to_$ref_i9gu5x(element_0));
        element_0.invoke_bnq13k_k$(tmp_20, ($this$invoke) => {
          var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(notification).content_1.url_1;
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp$ret$77;
            $l$block_1: {
              var myPart = substringAfter_0(substringAfter(tmp0_safe_receiver, '://'), _Char___init__impl__6a9atx(47));
              var urlLike = Companion_getInstance_1().fromUrlString_j9awpo_k$(myPart);
              if (get_AutoRoutes().parse_l5bwev_k$(urlLike) == null) {
                tmp$ret$77 = null;
                break $l$block_1;
              }
              tmp$ret$77 = () => {
                var tmp0_elvis_lhs = get_AutoRoutes().parse_l5bwev_k$(urlLike);
                return tmp0_elvis_lhs == null ? Empty_instance : tmp0_elvis_lhs;
              };
            }
            tmp = tmp$ret$77;
          }
          return tmp;
        });
        element_0.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element_0);
        element.onStartup_vrxh3i_k$();
        $this$children.addChild_2qpft2_k$(element);
        return Unit_instance;
      });
      element_5.onStartup_vrxh3i_k$();
      this_5.addChild_2qpft2_k$(element_5);
      element_0.onStartup_vrxh3i_k$();
      this_1.addChild_2qpft2_k$(element_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_6 = new (Separator())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_6);
      element.willAddChild_hz2iwc_k$(element_6);
      element_6.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_6);
      // Inline function 'com.lightningkite.kiteui.views.compact' call
      var tmp$ret$81 = themed(element, CompactSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_6 = themed(tmp$ret$81, TextOnlyButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_7 = new (Button())(this_6.get_context_h02k06_k$());
      ensureOutermostElement(element_7);
      this_6.willAddChild_hz2iwc_k$(element_7);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      var this_7 = get_centered(element_7);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_8 = new (RowOrCol())(this_7.get_context_h02k06_k$());
      ensureOutermostElement(element_8);
      this_7.willAddChild_hz2iwc_k$(element_8);
      element_8.set_vertical_nuap32_k$(false);
      element_8.set_gap_jwjroq_k$(get_dp(2));
      text(themed(get_bold(get_centered(element_8)), SmallTextSemantic_getInstance()), 'View All');
      // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
      var this_8 = get_centered(element_8);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_9 = new (IconView())(this_8.get_context_h02k06_k$());
      ensureOutermostElement(element_9);
      this_8.willAddChild_hz2iwc_k$(element_9);
      element_9.set_source_3o5lkf_k$(get_arrowForward(Companion_getInstance_0()).resize_q1xpz0_k$(get_rem(1)));
      var tmp_6 = KMutableProperty0();
      var tmp_7 = IconView$_get_description_$ref_x7iif6(element_9);
      var tmp_8 = getPropertyCallableRef('description', 0, tmp_6, tmp_7, IconView$_set_description_$ref_rpvc1e(element_9));
      element_9.invoke_bnq13k_k$(tmp_8, app$lambda$lambda$lambda$lambda_4);
      element_9.onStartup_vrxh3i_k$();
      this_8.addChild_2qpft2_k$(element_9);
      element_8.onStartup_vrxh3i_k$();
      this_7.addChild_2qpft2_k$(element_8);
      onClick(element_7, VOID, VOID, VOID, app$lambda$lambda$lambda$slambda_0(element_7));
      element_7.onStartup_vrxh3i_k$();
      this_6.addChild_2qpft2_k$(element_7);
      element.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element);
      return Unit_instance;
    });
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    return Unit_instance;
  }));
}
function app$lambda$lambda$lambda($this$remember) {
  _init_properties_App_kt__fk8usv();
  var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(get_currentSession());
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : $this$remember.invoke_r7m7el_k$(tmp0_safe_receiver.myNotifications_1);
  return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
}
function app$lambda$lambda$lambda_0($this$remember) {
  _init_properties_App_kt__fk8usv();
  var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(get_currentSession());
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$remember.invoke_r7m7el_k$(tmp0_safe_receiver.myNotifications_1);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.count' call
      var tmp_0;
      if (isInterface(tmp1_safe_receiver, Collection())) {
        tmp_0 = tmp1_safe_receiver.isEmpty_y1axqb_k$();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = 0;
        break $l$block;
      }
      var count = 0;
      var _iterator__ex2g4s = tmp1_safe_receiver.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        if (element.read_1 == null) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$0 = count;
    }
    tmp = tmp$ret$0;
  }
  var tmp2_elvis_lhs = tmp;
  return tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
}
function IconView$_get_description_$ref_x7iif6(p0) {
  return constructCallableReference(() => p0.description_1, 0, 0, 184, VOID, [p0]);
}
function IconView$_set_description_$ref_rpvc1e(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_description_s1386w_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 185, VOID, [p0]);
}
function app$lambda$lambda$lambda_1($this$invoke) {
  _init_properties_App_kt__fk8usv();
  return 'Notifications';
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return constructCallableReference(() => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.native_1.content_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  }, 0, 0, 92, VOID, [p0]);
}
function TextView$_set_content_$ref_pketfb(p0) {
  return constructCallableReference((p0_0) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.native_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(p0_0) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = p0_0;
    }
    tmp.set_content_i5lrjv_k$(tmp_0);
    return Unit_instance;
  }, 1, 0, 93, VOID, [p0]);
}
function app$lambda$lambda$lambda$lambda($this$styledHeader) {
  _init_properties_App_kt__fk8usv();
  return 'Notifications';
}
function app$lambda$lambda$lambda$lambda_0($this$shownWhen) {
  _init_properties_App_kt__fk8usv();
  var tmp0_safe_receiver = $this$shownWhen.invoke_r7m7el_k$(get_currentSession());
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$shownWhen.invoke_r7m7el_k$(tmp0_safe_receiver.myNotifications_1);
  return (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.isEmpty_y1axqb_k$()) === false;
}
function app$lambda$lambda$lambda$lambda_1($this$invoke) {
  _init_properties_App_kt__fk8usv();
  return 'Mark as read';
}
function app$lambda$lambda$lambda$slambda($this_navSidebar) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp = $this_navSidebar.invoke_r7m7el_k$(get_currentSessionNotNull()).get_notifications_jts33z_k$();
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(TCGNotification()), arrayOf([]), false))]), false));
    var tmp$ret$2 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$2);
    var tmp_1 = and(eq(get_user(it), new (ID())($this_navSidebar.invoke_r7m7el_k$(get_currentSessionNotNull()).userId_1)), eq(get_read(it), null));
    // Inline function 'com.lightningkite.services.database.modification' call
    // Inline function 'kotlin.apply' call
    var this_0 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_2 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(TCGNotification()), arrayOf([]), false))]), false));
    var tmp$ret$9 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
    var it_0 = new (DataClassPathSelf())(tmp$ret$9);
    this_0.assign_vtsfu6_k$(get_read(it_0), now());
    var tmp$ret$5 = this_0.build_1k0s4u_k$();
    yield* tmp.bulkModify_ugvnv2_k$(new (MassModification())(tmp_1, tmp$ret$5), $completion);
    return Unit_instance;
  }), 0);
}
function app$lambda$lambda$lambda$lambda_2($this$shownWhen) {
  _init_properties_App_kt__fk8usv();
  var tmp0_safe_receiver = $this$shownWhen.invoke_r7m7el_k$(get_currentSession());
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$shownWhen.invoke_r7m7el_k$(tmp0_safe_receiver.myNotifications_1);
  return (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.isEmpty_y1axqb_k$()) === true;
}
function app$lambda$lambda$lambda$lambda_3(it) {
  _init_properties_App_kt__fk8usv();
  return it._id_1;
}
function app$lambda$lambda$lambda$lambda$slambda($this_navSidebar, $notification) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = $this_navSidebar.invoke_r7m7el_k$(get_currentSessionNotNull()).get_notifications_jts33z_k$().get_6ueaa7_k$($this_navSidebar.invoke_r7m7el_k$($notification)._id_1);
    // Inline function 'com.lightningkite.services.database.modification' call
    // Inline function 'kotlin.apply' call
    var this_0 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(TCGNotification()), arrayOf([]), false))]), false));
    var tmp$ret$4 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$4);
    this_0.assign_vtsfu6_k$(get_read(it), now());
    var tmp$ret$0 = this_0.build_1k0s4u_k$();
    yield* tmp.modify_ff53f_k$(tmp$ret$0, $completion);
    return Unit_instance;
  }), 1);
}
function app$lambda$lambda$lambda$lambda$slambda_0($$this$link, $markRead) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $$this$link.invoke_s9332g_k$($markRead);
    closePopovers($$this$link.get_context_h02k06_k$());
    return Unit_instance;
  }), 0);
}
function app$lambda$lambda$lambda$lambda$lambda($this$invoke) {
  _init_properties_App_kt__fk8usv();
  return 'Unread';
}
function IconView$_get_shown_$ref_js8irt(p0) {
  return constructCallableReference(() => p0.get_shown_iyiju0_k$(), 0, 0, 186, VOID, [p0]);
}
function IconView$_set_shown_$ref_9ilxmr(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_shown_mavbz5_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 187, VOID, [p0]);
}
function IconView$_get_visible_$ref_7ldslk(p0) {
  return constructCallableReference(() => p0.get_visible_8zfvk9_k$(), 0, 0, 188, VOID, [p0]);
}
function IconView$_set_visible_$ref_mp0dqc(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_visible_w9mvj4_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 189, VOID, [p0]);
}
var app$$inlined$produceExactlyOneElement$5$1$8$8$10$1Class;
function app$$inlined$produceExactlyOneElement$5$1$8$8$10$1() {
  if (app$$inlined$produceExactlyOneElement$5$1$8$8$10$1Class === VOID) {
    class $ {
      invoke_h6mny6_k$(theme) {
        return theme.copy$default_vpegf4_k$('bold', VOID, theme.font_1.copy$default_d05kcn_k$(VOID, VOID, true)).withoutBack_1;
      }
    }
    protoOf($).plus_duvq05_k$ = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    app$$inlined$produceExactlyOneElement$5$1$8$8$10$1Class = $;
  }
  return app$$inlined$produceExactlyOneElement$5$1$8$8$10$1Class;
}
function Link$_get_to_$ref_jq7esp(p0) {
  return constructCallableReference(() => p0.to_1, 0, 0, 168, VOID, [p0]);
}
function Link$_set_to_$ref_i9gu5x(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_to_opdqsp_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 169, VOID, [p0]);
}
function app$lambda$lambda$lambda$lambda_4($this$invoke) {
  _init_properties_App_kt__fk8usv();
  return 'View all';
}
function app$lambda$lambda$lambda$slambda_0($$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    get_pageNavigator($$this$button.get_context_h02k06_k$()).navigate_sm5lxf_k$(new (NotificationListPage())());
    closePopovers($$this$button.get_context_h02k06_k$());
    return Unit_instance;
  }), 0);
}
var properties_initialized_App_kt_kalemn;
function _init_properties_App_kt__fk8usv() {
  if (!properties_initialized_App_kt_kalemn) {
    properties_initialized_App_kt_kalemn = true;
    defaultTheme = get_tcgTheme();
    appTheme = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(get_defaultTheme());
    fcmToken = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
    setFcmToken = setFcmToken$lambda;
    backOfficeRoles = setOf([UserRole_Admin_getInstance(), UserRole_Developer_getInstance(), UserRole_Root_getInstance()]);
  }
}
//region block: exports
export {
  IconView$_get_shown_$ref_js8irt as IconView$_get_shown_$ref_js8irt2lifqkpdy4lgk,
  IconView$_set_shown_$ref_9ilxmr as IconView$_set_shown_$ref_9ilxmras82mdlnvzt8,
  IconView$_get_visible_$ref_7ldslk as IconView$_get_visible_$ref_7ldslk51pr2ktrf3cy,
  IconView$_set_visible_$ref_mp0dqc as IconView$_set_visible_$ref_mp0dqc3hhaf8c2nn3ih,
  Link$_get_to_$ref_jq7esp as Link$_get_to_$ref_jq7esp1qhuglz6kwpan,
  Link$_set_to_$ref_i9gu5x as Link$_set_to_$ref_i9gu5xmkiv49juwaf,
  TextView$_get_content_$ref_4pzcwl as TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9,
  TextView$_set_content_$ref_pketfb as TextView$_set_content_$ref_pketfb11e282hr0m0jl,
  IconView$_get_description_$ref_x7iif6 as IconView$_get_description_$ref_x7iif61khv8gb32hpy6,
  IconView$_set_description_$ref_rpvc1e as IconView$_set_description_$ref_rpvc1e1z9j41dqp1rw7,
  FullscreenPage as FullscreenPage2qcc83o0veqoh,
  get_appTheme as get_appTheme31d66tq0vhtg5,
  app as app3jx72ykpxh7n4,
  get_fcmToken as get_fcmTokenr2vb68z9flza,
  isBackOfficeUser as isBackOfficeUser15lhmu7ztwvih,
  managesFamilies as managesFamiliesklgx21qxhvef,
  managesLocations as managesLocations3e0r20fvtj1ym,
  managesProviders as managesProviders2tknldxk4b8ta,
  managesSomething as managesSomething2ap6xsvopocgf,
  seesCareDetail as seesCareDetail2hs0zn8tddwdw,
};
//endregion

//# sourceMappingURL=App.mjs.map
